import { CheckoutState, Group, Agreement } from './../checkout/checkout.reducer';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CheckoutService } from '../services/checkout.service';
import { ValueUnwrapper } from '@angular/core/src/change_detection/change_detection';
import { CartService } from '../services/cart.service';
import { ApiService } from '../services/api.service';

@Component({
    selector: 'service-offer-summary',
    templateUrl: './service-offer-summary.component.html',
    styleUrls: ['../../assets/css/bootstrap.min.css', '../../assets/sass/checkout.scss']
})
export class ServiceOfferSummaryComponent {

    services: any = [];

    objectKeys = null;

    constructor(
        private router: Router,
        private checkoutService: CheckoutService,
        private cartService: CartService,
        private apiService: ApiService
    ) {
        this.getServicesFromActualCart();
    }

    ngOnInit() {
        this.objectKeys = Object.keys;
    }

    getServicesFromActualCart() {
        this.services = [];
        if (this.cartService.checkIsActiveCart()) {
            return this.apiService.get(`/shopping-cart/${this.cartService.cart}`).subscribe(response => {
                this.services = response.data.items;
            }, error => {
                this.services = [];
            });
        }
    }

    removeService(item){
        if(this.cartService.checkIsActiveCart()){
            return this.apiService.delete(`/shopping-cart/${this.cartService.cart}/item/${item.id}`).subscribe(response => {
                this.getServicesFromActualCart();
            }, error => {

            });
        }
    }

    getParentName(parentName) {
        if (parentName.match(/\#/)) {
            const names = parentName.split('#');
            return names[0];
        }
        return parentName;
    }

    returnToServices(parentName) {
        if (parentName.match(/\#/)) {
            const names = parentName.split('#');
            this.router.navigateByUrl('/service/offer?for_service=' + names[1]);
            return true;
        }
        if(parentName === 'Cloud.VPS'){
            this.router.navigateByUrl('/checkout/vm');
            return true;
        }
        this.router.navigateByUrl('/service/offer');
    }


    goToCompanySelect() {
        this.router.navigateByUrl('/checkout/company');
    }

    getTotalAmount(notSingle) {
        let total = 0.00
        for (let serviceParent in this.services) {
            if (this.services.hasOwnProperty(serviceParent)) {
                const parentServices = this.services[serviceParent];
                parentServices.forEach((service) => {
                    total = (total + ((notSingle && !service.single) || !notSingle ? (service.netto * service.count) : 0.00));
                });
            }
        }
        return total;
    }
}



// WEBPACK FOOTER //
// ./src/app/service/service-offer-summary.component.ts